import { ROUTES } from "@/lib/constants";

/* Routes whose page owns the remaining viewport and scrolls internally, rather
   than growing a document scrollbar (the chat surfaces). The shell sizes these
   to exactly the space left under TopBar; the page then fills it with h-full
   and must never do viewport math of its own. Keeping the arithmetic in one
   place is the point — when it lived in both AppShell and AgentPage the two
   drifted and /assistant overflowed the viewport by md:pb-28 (7rem), producing
   a second scrollbar and a dead band under the composer.

   Prefixes, not exact paths: an open workspace conversation lives at
   /assistant/w/<questId> and is the same full-height chat surface. Listed as
   the ROUTES constant rather than a literal so that renaming the route moves
   its shell sizing with it instead of silently leaving this list behind. */
const FULL_HEIGHT_ROUTE_PREFIXES: readonly string[] = [ROUTES.ASSISTANT];

/**
 * Whether `pathname` is a page that fills the viewport instead of scrolling the
 * document. Pure and pathname-only, so the prefix rule can be tested directly
 * rather than inferred from rendered class names.
 */
export function isFullHeightRoute(pathname: string): boolean {
  return FULL_HEIGHT_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
